/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { Window, WindowType }       from './window';
import { DocumentWindowManager }    from './document.window.manager';
import { DocumentMetadata }         from './document.metadata';
import { Logger }                   from '@/util/logger';
import { FileBrowserWindow}         from './file.browser.window';
import { FileBrowserMetadata }      from './file.browser.metadata';
import { ScenarioBrowserWindow }    from './scenario.browser.window';
import { ScenarioBrowserMetadata }  from './scenario.browser.metadata';
import { StringLineViewerWindow }   from './string.line.viewer.window';
import { StringLineViewerMetadata } from './string.line.viewer.metadata';
import { JobsViewerWindow}          from './jobs.viewer.window';
import { JobsViewerMetadata }       from './jobs.viewer.metadata';
import { WorkBloxEditorWindow }     from './work.blox.editor.window';
import { WorkBloxEditorMetadata }   from './work.blox.editor.metadata';
import { DiversionEditorWindow }    from './diversion.editor.window';
import { DiversionEditorMetadata }  from './diversion.editor.metadata';
import { TSOEditorWindow }          from './t.s.o.editor.window';
import { TSOEditorMetadata }        from './t.s.o.editor.metadata';
import { SearchWindow}              from './search.window';
import { SearchMetadata }           from './search.metadata';
import { JsonBrowserWindow }        from './json.browser.window';
import { KPITableViewerWindow }     from './k.p.i.table.viewer.window';
import { JSONBrowserMetadata }      from './json.browser.metadata';
import { TextEditorWindow }         from './text.editor.window';
import { TextEditorMetadata }       from './text.editor.metadata';
import { UserLogViewerWindow }      from './user.log.viewer.window';
import { UserLogViewerMetadata }    from './user.log.viewer.metadata';
import { BatchViewerMetadata }      from './batch.viewer.metadata';
import { BatchViewerWindow }        from './batch.viewer.window';
import { RegressionViewerMetadata } from './regression.viewer.metadata';
import { RegressionViewerWindow }   from './regression.viewer.window';
import { ConnectionViewerMetadata } from '@/screens/ide/connection.viewer.metadata';
import { ConnectionViewerWindow }   from '@/screens/ide/connection.viewer.window';

/**
 *
 * @class DocumentWindowFactory
 *
 * @brief factory for tabs in the main document tabbed view of the GUI
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class DocumentWindowFactory  {

  /** create a (tab compatible) window from the given meta data (memento) for the window */
  public static fromMeta(meta: DocumentMetadata,  manager: DocumentWindowManager) {

    switch (meta.type) {

      case WindowType.FileBrowser: {

        return new FileBrowserWindow(meta as FileBrowserMetadata, manager);
      }

      case WindowType.ScenarioBrowser: {

        return new ScenarioBrowserWindow(meta as ScenarioBrowserMetadata, manager);
      }

      case WindowType.ConnectionViewer: {

        return new ConnectionViewerWindow(meta as ConnectionViewerMetadata, manager);
      }

      case WindowType.StringLineViewer: {

        return new StringLineViewerWindow(meta as StringLineViewerMetadata, manager);
      }

      case WindowType.Jobs: {

        return new JobsViewerWindow(meta as JobsViewerMetadata, manager);
      }

      case WindowType.KPITable: {

        return new KPITableViewerWindow(meta as JobsViewerMetadata, manager);
      }

      case WindowType.WorkBloxEditor: {

        return new WorkBloxEditorWindow(meta as WorkBloxEditorMetadata, manager);
      }

      case WindowType.DiversionEditor: {

        return new DiversionEditorWindow(meta as DiversionEditorMetadata, manager);
      }

      case WindowType.TSOEditor: {

        return new TSOEditorWindow(meta as TSOEditorMetadata, manager);
      }

      case WindowType.JSONBrowser: {

        return new JsonBrowserWindow(meta as JSONBrowserMetadata, manager);
      }

      case WindowType.TextEditor: {

        return new TextEditorWindow(meta as TextEditorMetadata, manager);
      }

      case WindowType.Search: {

        return new SearchWindow(meta as SearchMetadata, manager);
      }

      case WindowType.UserLogViewer: {

        return new UserLogViewerWindow(meta as UserLogViewerMetadata, manager);
      }

      case WindowType.BatchViewer: {

        return new BatchViewerWindow(meta as BatchViewerMetadata, manager);
      }

      case WindowType.RegressionViewer: {

        return new RegressionViewerWindow(meta as RegressionViewerMetadata, manager);
      }
    }

    return null;
  }
}
